import React from 'react';
import { useEffect, useState } from "react";
import axios from "axios";
import { getAllTiles, getUserTilesById, updateUserTiles } from '../services/dashboardservice';
import { useDispatch } from "react-redux";
import { setLoading } from "../redux/appSlice";
import './alertmodal.css';
import { setLocalStorage } from '../global';



const AddMoreModal = ({userId, setShowModal, userTilesRes, setVisibleTiles}) => {
  const dispatch = useDispatch();
  const [allTiles, setAllTiles] = useState([]);
  const [selectedTiles, setSelectedTiles] = useState([]);

  // Fetch master tiles + user tiles
  useEffect(() => {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const fetchData = async () => {
      try {
        dispatch(setLoading({ data: true }));
        const allTilesRes = await getAllTiles(source);
        if (allTilesRes.sts == 0) {
            const { sts, ...restTiles } = allTilesRes;
            setAllTiles(restTiles.data);
        }
        dispatch(setLoading({ data: false }));

        setSelectedTiles(userTilesRes.map(t => t.id));
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, [userId]);

  const handleChange = (tileId) => {
    setSelectedTiles((prev) =>
      prev.includes(tileId) ? prev.filter((id) => id !== tileId) : [...prev, tileId]
    );
  };

  const handleSave = async () => {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    try {
        dispatch(setLoading({ data: true }));

      await updateUserTiles({
        userId,
        tileIds: selectedTiles,
        createdBy: 1
      })
  
      const tilesRS = await getUserTilesById(userId, source);
      dispatch(setLoading({ data: false }));

      const { sts, ...restTiles } = tilesRS;
      setLocalStorage("tilesData", restTiles.data);
      setVisibleTiles(restTiles.data);
      setShowModal(false);
    } catch (err) {
      alert("Error updating tiles: " + err.message);
    }
  };


    window.onclick = function (event) {
        var modal = document.getElementById("myModal");
        if (event.target == modal) {
            setShowModal(false)
        }
        if (event.target == modal) {
            setShowModal(false)     
        }
    }

    const onFirstClick = () => {
        setShowModal(false)
    
    }


    return <div id="myModal" className="modal">
              <div className="card shadow-sm p-3 mb-4 addmore-header">
                <h5 className="mb-3">Manage In-process Tiles Breakup</h5>
                <div className="row tiles-row">
                    {allTiles.map((tile) => (
                    <div key={tile.id} className="col-md-6 mb-2">
                        <div key={tile.id}>
                            <label className="small-switch">
                                <input 
                                  type="checkbox"
                                  className="form-check-input"
                                  id={`tile-${tile.id}`}
                                  checked={selectedTiles.includes(tile.id)}
                                  onChange={() => handleChange(tile.id)}
                                />
                                <span className="small-slider round"></span>
                            </label>
                            <label htmlFor={`tile-${tile.id}`} className="small-content-check">{tile.name}</label>
                        </div>
                    </div>
                    ))}
                </div>
                <button className="btn btn-primary mt-3" onClick={handleSave}>
                    Save Preferences
                </button>
              </div>
            </div>
}

export default AddMoreModal;